/**
 * Inspire-hub 2 (www.giap.pl)
 *
 * Copyright © GIAP sp.z.o.o. All rights reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Krzysztof Gregorowicz <gregorowicz.k@gmail.com>, February 2017
 */

/* eslint-disable max-len */
/* flow-disable */

import React, { PropTypes } from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import GrayPanel from '../../components/GrayPanel/GrayPanel';
import RodoContent from '../../components/RodoContent';
import AttachmentsPanel from '../../components/AttachmentsPanel';
import { connect } from 'react-redux';
import Select from 'react-select';
import { runService } from '../../actions/eservices';
import PowrotDoListyEuslug from '../../components/PowrotDoListyEuslug/PowrotDoListyEuslug';
import { isMobileView, isTabletView, renderHelpDesc } from '../../components/utils/utils';
import EmptyFileDownloader from '../../components/EmptyFileDownloader';
import CustomizedMap from './CustomizedMap';
import history from '../../core/history';
import pans from './panStyle.scss';
import ModalAlert from './ModalAlert';
import { DecisionContainer, PersonalDataContainer } from '../../containers';
import _ from 'lodash';
import fetch from '../../core/fetch';
import agentConfig from './agent';
import loadingData from './loading';

import v from './validators';


const btnStyle = {
  borderRadius: 0,
  border: 'none',
  padding: '10px 40px',
  marginLeft: '10px',
};

const InfoTypeDict = {
  adres: {
    label: 'Adres',
    editable: true,
  },
  okres: {
    label: 'Okres dzierżawy [lata]',
    editable: true,
  },
};

const isPartOptions = [
  {
    label: 'TAK',
    value: 'części działki',
    state: 'isPart',
  },
  {
    label: 'NIE',
    value: 'działki',
    state: 'isPart',
  },
];

const przeznaczenieOptions = [
  {
    label: 'Uprawy rolne',
    value: 'Uprawy rolne',
    state: 'przeznaczenie',
  },
  {
    label: 'Ogródek warzywny',
    value: 'Ogródek warzywny',
    state: 'przeznaczenie',
  },
  {
    label: 'Teren rekreacyjny',
    value: 'Teren rekreacyjny',
    state: 'przeznaczenie',
  },
  {
    label: 'Działalność handlowo-usługowa',
    value: 'Działalność handlowo-usługowa',
    state: 'przeznaczenie',
  },
  {
    label: 'Ogródki gastronomiczne',
    value: 'Ogródki gastronomiczne',
    state: 'przeznaczenie',
  },
  {
    label: 'Parking',
    value: 'Parking',
    state: 'przeznaczenie',
  },
  {
    label: 'Tereny baz i składów',
    value: 'Tereny baz i składów',
    state: 'przeznaczenie',
  },
  {
    label: 'Krótkotrwałe imprezy reklamowo-komercyjne',
    value: 'Krótkotrwałe imprezy reklamowo-komercyjne',
    state: 'przeznaczenie',
  },
  {
    label: 'Potykacz - stojak reklamowy',
    value: 'Potykacz - stojak reklamowy',
    state: 'przeznaczenie',
  },
  {
    label: 'Inne',
    value: 'Inne',
    state: 'przeznaczenie',
  },
];

const parcelTypeOptions = [
  {
    label: 'zabudowana',
    value: 'zabudowanej',
    state: 'parcelType',
  },
  {
    label: 'niezabudowana',
    value: 'niezabudowanej',
    state: 'parcelType',
  },
  {
    label: 'przeznaczona do użytkowania rolniczego',
    value: 'przeznaczonej do użytkowania rolniczego',
    state: 'parcelType',
  },
];

const InfoTypeDict2 = {
  isPart: {
    label: 'Czy część działki?',
    editable: true,
    type: 'Select',
    options: isPartOptions,
  },
  parcelType: {
    label: 'Rodzaj nieruchomości:',
    editable: true,
    type: 'Select',
    options: parcelTypeOptions,
  },
  przeznaczenie: {
    label: 'Przeznaczenie dzierżawy',
    editable: true,
    type: 'Select',
    options: przeznaczenieOptions,
  },
};

const InfoTypeDict3 = {
  przeznaczenie: {
    label: 'Przeznaczenie dzierżawy',
    editable: true,
    type: 'Select',
    options: przeznaczenieOptions,
  },
};


class DzierzawaNieruchomosci extends React.Component {
  state = {
    info: {
      isPart: null,
      partArea: null,
      adres: null,
      przeznaczenie: null,
      option: null,
      okres: null,
      parcelType: null,
      agentAdd: 'NIE',
      agentName: null,
      agentAddress: null,
      agentPostOffice: null,
      agentPostalCode: null,
      agentPhoneNumber: null,
      agentMotionAddress: null,
    },
    selectedParcels: [],
    selectedRoads: [],
    errors: {},
    errorTitle: '',
    errorText: '',
    showError: false,
    eserviceDistrict: null,
    attachments: null,
    loading: false,
    isMounted: false,
  };

  elseString = '.....................';
  spanStyle = {
    color: 'red',
  };

  validators = {
    adres: [v.NotNull],
    przeznaczenie: [v.NotSelected],
    okres: [v.NotNull, v.isStrictInteger],
    option: [],
    partArea: [],
    isPart: [],
    parcelType: [],
  };

  errorSpanStyle = {
    color: 'red',
    fontSize: '10px',
  };

  nextStep = '/eservices/eserviceSummary/';

  componentDidMount() {
    fetch(`${process.env.API_URL}/eservice/${this.props.district}/${this.props.query.serviceType}`)
      .then(r => r.json())
      .then(resp => {
        this.setState({
          eserviceDistrict: resp,
        }, () => this.updateValidators());
      });

    this.setState({ isMounted: true });
  }

  updateValidators = () => {
    if (this.props.prefix === 'hrubieszow') {
      this.validators.isPart = [v.NotSelected];
      this.validators.parcelType = [v.NotSelected];
    }
  }

  onHide = () => this.setState({ showError: false });

  setParcels = (parcels, callback = null) => this.setState({ selectedParcels: parcels });
  setRoads = (roads, callback = null) => this.setState({ selectedRoads: roads });

  onChangeSelect = (e, group) => {
    const name = e.state;
    this.setState(
      {
        [group]: {
          ...this.state[group],
          [name]: e.value,
        },
      },
      () => this.validate(group, name),
    );
  }

  onChange = (e, group) => {
    const name = e.target.name;
    this.setState(
      {
        [group]: {
          ...this.state[group],
          [name]: e.target.value,
        },
      },
      () => this.validate(group, name),
    );
  };

  onChangeAttachments = (attachments, errorMessage) => {
    const errorText = errorMessage.errorText;
    const errorTitle = errorMessage.errorTitle;
    const showError = errorMessage.showError;
    this.setState({ attachments, errorText, errorTitle, showError });
  }

  validateField = (group, field) => {
    const checks = [];
    if (Object.keys(this.validators).indexOf(field) > -1) {
      for (const validator of this.validators[field]) {
        const check = validator(this.state[group][field]);
        if (check) checks.push(check);
      }
    }
    return checks;
  };

  validateGroup = group => {
    const fields = Object.keys(this.state[group]);
    const errors = {};
    for (const f of fields) {
      const checks = this.validateField(group, f);
      errors[f] = checks;
    }
    return errors;
  };

  validate = (group, field = null, callback = null) => {
    let newState = null;
    if (field) {
      if (Object.keys(this.validators).indexOf(field) > -1) {
        const checks = this.validateField(group, field);
        newState = {
          errors: {
            ...this.state.errors,
            [field]: checks,
          },
        };
      }
    } else if (group) {
      const errors = this.validateGroup(group);
      newState = { errors };
    } else {
      let errors = {};
      const grupy = ['info'];
      for (const g of grupy) {
        const err = this.validateGroup(g);
        errors = { ...errors, ...err };
      }
      newState = { errors: { ...errors } };
    }
    if (newState) {
      if (callback) {
        this.setState(newState, callback);
      } else {
        this.setState(newState);
      }
    }
  };

  validateAttachmentsContent = () => {
    if (this.state.attachments) {
      for (const attachment of this.state.attachments) {
        if (attachment.name.length < 1) return true;
      }
    }
    return false;
  }

  haseErrors = () => {
    for (const key of Object.keys(this.state.errors)) {
      if (this.state.errors[key].length > 0) return true;
    }
    return false;
  };

  postValidation = () => {
    const hasFieldErrors = this.haseErrors();
    if (this.state.selectedParcels.length === 0) {
      return this.setState({
        errorText: 'Nie wybrano działki ewidencyjnej. Prosimy o wskazanie działki',
        errorTitle: 'Błędnie wypełniony formularz',
        showError: true,
        loading: false,
      });
    }

    if (hasFieldErrors) {
      return this.setState({
        errorText: 'Uzupełnij pola obowiązkowe.',
        errorTitle: 'Błędnie wypełniony formularz.',
        showError: true,
        loading: false,
      });
    }

    if (!((this.state.attachments || []).length)) {
      return this.setState({
        errorText: 'Wymagane jest dodanie załączników do składanego wniosku',
        errorTitle: 'Brak załączników.',
        showError: true,
        loading: false,
      });
    }

    const hasEmptyAttachment = this.validateAttachmentsContent();
    if (hasEmptyAttachment) {
      return this.setState({
        errorText: 'Przynajmniej jeden załącznik jest pusty. Dodaj plik do załączników',
        errorTitle: 'Pusty załącznik.',
        showError: true,
        loading: false,
      });
    }

    if (!hasFieldErrors && this.state.selectedParcels.length > 0) {
      this.props
        .runService(this.props.serviceInfo.eservice.shortName, this.props.district, {
          mpzpOwner: { ...this.state.mpzpOwner },
          info: { ...this.state.info },
          dzialki: this.state.selectedParcels,
          selectedParcels: this.state.selectedParcels,
          user: {
            ...this.props.serviceInfo.user,
          },
          shortName: this.props.serviceInfo.eservice.shortName,
          urzad: this.props.districts[this.props.prefix],
          numer_ksiegi: this.state.info.numer_ksiegi,
          attachments: this.state.attachments,
        })
        .then(resp => {
          this.setState({
            loading: false }, () =>
            this.redirectToSummary(resp.jobId));
        });
    }
  };

  redirectToSummary = (jobId) => {
    window.location.href = `${this.nextStep}${jobId}`;
  };

  startService = () => {
    this.validate(null, null, this.postValidation);
  };

  renderErrorsInSpan = (name_state) => {
    if (Object.keys(this.state.errors).indexOf(name_state) > -1 &&
      this.state.errors[name_state] !== null &&
      this.state.errors[name_state].length > 0) {
      const span = this.state.errors[name_state].map((val, index) => (
        <span key={index} style={this.errorSpanStyle}>
          {val}
        </span>
      ))
      return span;
    } return null;
  }

  getStandartInputErrorStyle = (name_state) => {
    const standardInputErrStyle = {
      width: '100%',
      ...this.getSelectErrorStyle(name_state),
    };
    return standardInputErrStyle;
  }

  getSelectErrorStyle = (name_state) => {
    const selectErrorStyle = {
      borderColor:
        Object.keys(this.state.errors).indexOf(name_state) > -1 &&
          this.state.errors[name_state] !== null &&
          this.state.errors[name_state].length > 0
          ? 'red'
          : '#ccc',
    };
    return selectErrorStyle;
  }

  renderOtherDest = () => {
    if (this.state.info.przeznaczenie === 'Inne') {
      this.validators.option = [v.NotNull];
      return (
        <div className="form-group">
          <label htmlFor="adres">Inne przeznaczenie dzierżawy</label>
          <input
            type="text"
            className="form-control"
            name="option"
            onChange={(e) => this.onChange(e, 'info')}
            style={this.getStandartInputErrorStyle('option')}
          />
          {/* RENDER ERROS IN SPAN */}
          {this.renderErrorsInSpan('option')}
        </div>);
    }
    this.validators.option = [];
    return (null);
  }

  renderParcelPart = () => {
    if (this.state.info.isPart === 'części działki') {
      this.validators.partArea = [v.NotNull, v.isNumber];
      return (
        <div className="form-group">
          <label htmlFor="partArea">Powierzchnia do wydzierżawienia [ha]</label>
          <input
            type="text"
            className="form-control"
            name="partArea"
            onChange={(e) => this.onChange(e, 'info')}
            style={this.getStandartInputErrorStyle('partArea')}
          />
          {/* RENDER ERROS IN SPAN */}
          {this.renderErrorsInSpan('partArea')}
        </div>);
    }
    this.validators.partArea = [];
    return (null);
  }

  render() {
    const isMobile = this.state.isMounted && isMobileView(window);
    const isTablet = this.state.isMounted && isTabletView(window);
    return (
      <div style={{ paddingTop: '20px' }}>
        <h3 style={{ textAlign: 'center' }}>
          {this.props.serviceInfo.eservice.title}
        </h3>
        <PersonalDataContainer userData={this.props.serviceInfo.user ? this.props.serviceInfo.user : null} />

        <GrayPanel
          title={'1. Teren'}
        >
          { renderHelpDesc(isMobile, isTablet) }
          <CustomizedMap
            serviceType={this.props.serviceInfo.eservice.shortName}
            setParcels={this.setParcels}
            setSelectDzialki={this.setSelectDzialki}
            selectedParcels={this.state.selectedParcels}
            obreby={this.props.serviceInfo.precints}
            district={this.props.districts[this.props.prefix]}
            prefix={this.props.prefix}
            mapState={this.props.mapstates[0]}
            settings={this.props.serviceInfo.eservice.mapConfig}
            dokumentType={this.props.serviceInfo.eservice}
          />
        </GrayPanel>
        {this.state.eserviceDistrict && this.state.eserviceDistrict.enableAgent ?
          <DecisionContainer
            title={'Pełnomocnik'}
            data={this.state.info}
            errors={this.state.errors}
            formDict={agentConfig.agentInfoDict}
            onChange={e => this.onChange(e, 'info')}
            onChangeSelect={e => this.onChangeSelect(e, 'info')}
          >
            <br />
            <p style={{ fontWeight: 'bold' }}>
            W przypadku złożenia pełnomocnictwa należy uiścić opłatę skarbową w wysokości 17 zł.
            </p>
          </DecisionContainer> : null }
        {this.state.info.agentAdd === 'TAK' ?
          <DecisionContainer
            title={'Dane identyfikacyjne pełnomocnika'}
            data={this.state.info}
            errors={this.state.errors}
            formDict={agentConfig.agentDict}
            onChange={e => this.onChange(e, 'info')}
          /> : null }

        {this.props.prefix === 'hrubieszow' ?
          <DecisionContainer
            title={'2. Przeznaczenie'}
            data={this.state.info}
            errors={this.state.errors}
            formDict={InfoTypeDict2}
            onChange={e => this.onChange(e, 'info')}
            onChangeSelect={e => this.onChangeSelect(e, 'info')}
          >
            {this.renderOtherDest()}
            {this.renderParcelPart()}
          </DecisionContainer> :
          <DecisionContainer
            title={'2. Przeznaczenie'}
            data={this.state.info}
            errors={this.state.errors}
            formDict={InfoTypeDict3}
            onChange={e => this.onChange(e, 'info')}
            onChangeSelect={e => this.onChangeSelect(e, 'info')}
          >
            {this.renderOtherDest()}
          </DecisionContainer>
      }

        <DecisionContainer
          title={'3. Dodatkowe informacje'}
          data={this.state.info}
          errors={this.state.errors}
          formDict={InfoTypeDict}
          onChange={e => this.onChange(e, 'info')}
        />

        <RodoContent prefix={this.props.prefix} />

        <GrayPanel title="Informacje o załącznikach" >
          
          <p><b>Do niniejszego wniosku należy dołączyć załączniki:</b></p>
          <p>1. Mapa sytuacyjna</p>

        </GrayPanel>

        <AttachmentsPanel onChangeAttachments={this.onChangeAttachments} showExtraText={this.props.districts[this.props.prefix].attachmentsToEpuapEnabled}/>
        <ModalAlert
          title={this.state.errorTitle}
          bodyText={this.state.errorText}
          show={this.state.showError}
          name="errorModal"
          onHide={this.onHide}
        />
        <ModalAlert
          title={loadingData.loadingTitle}
          bodyText={loadingData.loadingBody}
          show={this.state.loading}
          name="loadingModal"
          onHide={this.onHide}
          disableButton
        />

        {/* BUTTONS */}
        <div className="row mobile-row">
          <div className="col-sm-12">
            <PowrotDoListyEuslug position="left" prefix={this.props.prefix} />
            <EmptyFileDownloader position="left" prefix={this.props.prefix} serviceType={this.props.serviceInfo.eservice.shortName} />
            <button
              type="submit-lg"
              className={this.props.isDisabled ? 'btn btn-primary disabled' : 'btn btn-primary'}
              style={{ float: 'right', marginRight: '15px', ...btnStyle }}
              onClick={() => this.setState({ loading: true }, () => this.startService())}
            >
              Uruchom
            </button>
            {_.includes(this.props.serviceInfo.user.roles, 'superadmin') ? (
              <button
                type="submit-lg"
                className="btn btn-success"
                style={{ float: 'right', marginRight: '15px', ...btnStyle }}
                onClick={this.insertTestData}
              >
                Insert Test Data
              </button>
            ) : null}
            <button
              type="submit-lg"
              className="btn btn-default"
              style={{ float: 'right', marginRight: '15px', ...btnStyle }}
              onClick={history.goBack}
            >
              Anuluj
            </button>
          </div>
        </div>
      </div>
    );
  }
}

DzierzawaNieruchomosci.propTypes = {
  serviceInfo: PropTypes.object,
  district: PropTypes.string,
};

const mapState = state => ({
  current_service: state.eservices.current,
  districts: state.district.districts
});

const mapDispatch = {
  runService,
};

export default withStyles(pans)(
  connect(
    mapState,
    mapDispatch,
  )(DzierzawaNieruchomosci),
);



// WEBPACK FOOTER //
// src/routes/eservices/DzierzawaNieruchomosci.js